import { useRef } from 'react';
import PropTypes from 'prop-types';
import { mergeProps, useFocusRing, useTableCell } from 'react-aria';

import styles from './TableCell.module.scss';

const TableCell = ({ cell, state, type, className, ...props }) => {
    const ref = useRef();
    const { gridCellProps } = useTableCell({ node: cell }, state, ref);
    const { isFocusVisible, focusProps } = useFocusRing();

    const { horzAlign, vertAlign, wrapText } = cell?.props;

    return (
        <td
            className={[
                'govuk-table__cell',
                styles.cell,
                type === 'text' ? styles.text : styles.number,
                isFocusVisible ? styles.focus : null,
                wrapText ? styles.cellWrapped : null,
                horzAlign ? styles['horzAlign-' + horzAlign] : null,
                vertAlign ? styles['vertAlign-' + horzAlign] : null
            ].join(' ')}
            {...mergeProps(gridCellProps, focusProps)}
            ref={ref}
            data-testid={props['data-testid'] ? props['data-testid'] + '.td' : null}
        >
            {cell.rendered}
        </td>
    );
};

TableCell.propTypes = {
    cell: PropTypes.any,
    state: PropTypes.object,
    type: PropTypes.oneOf(['text', 'number']),
    className: PropTypes.string,
    'data-testid': PropTypes.string
};

TableCell.defaultProps = {
    type: 'text'
};

export default TableCell;
